/**
 * Tech-debt #4 — small leftovers that don't form their own family. CostUpdated
 * (Session 23) records a running per-transaction cost for the ConnectorRow.
 */
import { useCostStore } from '../useCostStore';
import type { CsmsCtx, CsmsEvent } from './context';

export function handleCostUpdated(event: CsmsEvent<'CostUpdated'>, ctx: CsmsCtx): void {
  // Only integer txids match a simulator-minted id; the response is empty
  // either way.
  if (Number.isFinite(event.transactionId) && Number.isInteger(event.transactionId)) {
    useCostStore.getState().setCost(event.transactionId, event.totalCost);
  }
  ctx.dispatcher.reply(ctx.messageId, {});
}
